import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 4.358a3.25 3.25 0 0 0-3.25 3.25v10A3.25 3.25 0 0 0 7 20.858h10a3.25 3.25 0 0 0 3.25-3.25v-10A3.25 3.25 0 0 0 17 4.358zm-4.75 3.25A4.75 4.75 0 0 1 7 2.858h10a4.75 4.75 0 0 1 4.75 4.75v10a4.75 4.75 0 0 1-4.75 4.75H7a4.75 4.75 0 0 1-4.75-4.75zM12 9.358a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m-4.75 3.25a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0m11.25-5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }